import * as React from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { InsuranceProgramFragment } from '@websky/graphql';
import { useTheme } from '../../../theme';
import { Included } from '../../../Icons';
import { Money } from '../../../Money';
import { useRenderers } from '../../../renderProps';
import { default as BaseButton } from '../../../BaseComponents/Button';
import { SafeHtml } from '@shared/ui';

interface Props {
	className?: string;
	insurance: InsuranceProgramFragment;
	policyUrl?: string;
	isSelected?: boolean;
	onClick?: () => void;
}

const InsuranceCard: React.FC<Props> = ({ className, insurance, policyUrl, isSelected, onClick }) => {
	const { InsuranceCard: css } = useTheme('InsurancePopup');
	const { t } = useTranslation('Checkout');

	const { renderInsuranceCardOptions } = useRenderers();

	const isConfirmed = !!policyUrl;

	const onDownload = () => {
		if (policyUrl) {
			window.open(policyUrl);
		}
	};

	return (
		<div
			className={cn(className, css.wrapper, {
				[css.active]: isSelected,
				[css.confirmed]: isConfirmed
			})}
		>
			<div className={css.header}>
				<div className={css.header_info}>
					<span className={css.header_rate}>{insurance.name}</span>
					<span className={css.header_description}>{t('price for all persons')}</span>
				</div>
				<span className={css.header_price}>
					<Money money={insurance.totalPrice} />
					{isSelected && Included}
				</span>
			</div>
			<div className={css.content}>
				<ul>
					{renderInsuranceCardOptions?.(insurance.options) ??
						insurance.options.map(({ name }, index) => <SafeHtml key={index} tag="li" html={name} />)}
				</ul>
				{policyUrl ? (
					<BaseButton className={css.button} onClick={onDownload} variant="optionEdit">
						{t('Download')}
					</BaseButton>
				) : isSelected ? (
					<BaseButton className={css.button_reject} onClick={onClick} variant="smallSecondary">
						{t('Reject')}
					</BaseButton>
				) : (
					<BaseButton className={css.button} onClick={onClick} variant="optionEdit">
						{t('Select')}
					</BaseButton>
				)}
			</div>
		</div>
	);
};

export default InsuranceCard;
